


































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import Resumable from 'resumablejs'
import File from './File.vue'
import axios from 'axios'
import dayjs from 'dayjs'
import helpers from '@/helpers'

interface NewOrder {
  number?: string;
  type?: string;
  lesson?: string;
  finishDate?: string;
  theme?: string;
  demand?: string;
  size?: string;
  price?: number;
  fileID?: number[];
  economics?: boolean;
  juridas?: boolean;
  humanitary?: boolean;
  technology?: boolean;
  languages?: boolean;
  userID?: number;
}

interface CreateFilesPartsResponse {
  id: number;
}

interface FileToLoad {
  file: Resumable.ResumableFile;
  id?: number;
  loaded: number;
}

@Component({ components: { File } })
export default class Order extends Vue {
  public files: FileToLoad[] = []

  private resumable = new Resumable({
    target: 'https://prepodam.ru/api/v2/files/parts'
  })

  public order: NewOrder = {}

  public finishDate: string = dayjs(new Date()).add(1, 'day').format('YYYY-MM-DDT20:00')

  public blocked = false
  public number = ''
  public userId = ''
  public type = ''
  public lesson = ''
  public theme = ''
  public demand = ''
  public size = ''

  mounted () {
    const token = this.$cookies.get('randomAdminId')

    const el = document.getElementById('addFile') as Element
    this.resumable.assignBrowse(el, false)

    const drop = document.getElementById('app') as Element
    this.resumable.assignDrop(drop)

    this.resumable.opts.headers = { token }

    this.resumable.on('fileAdded', (file: Resumable.ResumableFile) => {
      const toLoad: FileToLoad = { file: file, loaded: 0 }

      this.files.push(toLoad)
      this.resumable.upload()
    })

    this.resumable.on('fileSuccess', (file: Resumable.ResumableFile, resp: string) => {
      const parsed: CreateFilesPartsResponse = JSON.parse(resp)

      for (const curr of this.files) {
        if (curr.file.uniqueIdentifier !== file.uniqueIdentifier) {
          continue
        }

        curr.loaded = 100
        curr.id = parsed.id
        break
      }
    })

    this.resumable.on('fileError', (file: Resumable.ResumableFile) => {
      for (const curr of this.files) {
        if (curr.file.uniqueIdentifier !== file.uniqueIdentifier) {
          continue
        }

        curr.loaded = 0
        break
      }
    })

    this.resumable.on('fileProgress', (file: Resumable.ResumableFile) => {
      for (const curr of this.files) {
        if (curr.file.uniqueIdentifier !== file.uniqueIdentifier) {
          continue
        }

        curr.loaded = Math.trunc(file.progress(false) * 100)
        break
      }
    })

    this.userId = helpers.getQueryParameter(this.$route.query.user_id)
    this.number = helpers.getQueryParameter(this.$route.query.number)
    this.type = helpers.getQueryParameter(this.$route.query.type)
    this.lesson = helpers.getQueryParameter(this.$route.query.lesson)
    this.theme = helpers.getQueryParameter(this.$route.query.theme)
    this.demand = helpers.getQueryParameter(this.$route.query.demand)
    this.size = helpers.getQueryParameter(this.$route.query.size)

    if (helpers.getQueryParameter(this.$route.query.finish_date) !== '') {
      const dt = helpers.dateStringToInputValue(helpers.getQueryParameter(this.$route.query.finish_date))
      this.finishDate = dayjs(dt).format('YYYY-MM-DDT20:00')
    }
  }

  addOrder (e: Event) {
    e.preventDefault()

    this.blocked = true

    this.order.fileID = []

    for (const curr of this.files) {
      if (curr.id === undefined) {
        continue
      }

      this.order.fileID.push(curr.id)
    }

    if (this.finishDate === undefined) {
      this.blocked = false
      return
    }

    const dt = new Date(this.finishDate)

    this.order.finishDate = dt.toISOString()

    this.order.number = this.number
    this.order.type = this.type
    this.order.lesson = this.lesson
    this.order.theme = this.theme
    this.order.demand = this.demand
    this.order.size = this.size

    if (this.userId !== '') {
      this.order.userID = helpers.getAmount(this.userId)
    }

    const token = this.$cookies.get('randomAdminId')

    const headers = { token }

    axios.post('https://prepodam.ru/api/v2/order', this.order, { headers }).then(() => {
      window.location.href = '/adm/'
    }).catch((resp) => {
      alert(resp)
    }).finally(() => {
      this.blocked = false
    })
  }
}
